import styled, { css } from "styled-components";
import React from "react";
import breakpoints from "../../../styles/breakpoints";
import { header } from "../../../styles/variables";
import SideTray from "../../atoms/SideTray";

export const StyledSideTray = styled((props) => <SideTray {...props} />).attrs(() => ({
  displayName: "StyledSideTray",
}))`
  ${breakpoints.smUp} {
    padding-top: 40px;
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: 0;
      `}
  }
  ${breakpoints.smDown} {
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: ${header.mobileHeight};
      `}
  }
  padding: 0px 0px 120px 0px;
`;

export const WinesAddBottleTrayBody = styled.div<{
  backgroundColor: string;
}>`
  margin-bottom: 40px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
